import { useHistory, useLocation } from "react-router";
import { useAppSelector } from "redux/app/hooks";
import { TIPO_CARTAO_CONVENIO, TipoCartao } from "models/tipoCartao";
import lock_icon from "../../../../assets/images/padlock.png";
import AppButton from "../../../../components/AppButton/AppButton";
import { RouteNames } from "../../../../routes/routes";
import "./BloqueioQuerSegundaVia.css";
import Swal from "sweetalert2";
import { getItemLocalStore } from "utils/storeUtils";
import { LOCAL_STORE_CLIENTE } from "../../../../constants";

/**
 * ? Representa a tela onde o usuário pode optar ou não pela segunda via do cartão, o direcionando para
 * ? outra tela que contém a mensagem adequada de acordo com a escolha dele.
 * **/
const BloqueioQuerSegundaVia = () => {
  const history = useHistory();
  const { state } = useLocation<{ tipoCartaoSelecionado?: TipoCartao }>();
  const tipoCartaoSelecionado = state?.tipoCartaoSelecionado;
  const {
    motivo: { selecionado },
  } = useAppSelector((state) => state);

  const { cartaoAtual, cartaoAtualConvenio, dadosLogin } = getItemLocalStore(
    LOCAL_STORE_CLIENTE
  );
  const cartaoSelecionado =
    tipoCartaoSelecionado === TIPO_CARTAO_CONVENIO
      ? cartaoAtualConvenio && {
          ...cartaoAtualConvenio,
          numeroCartao: dadosLogin?.numeroCartaoConvenio,
        }
      : cartaoAtual && {
          ...cartaoAtual,
          numeroCartao: dadosLogin?.numeroCartaoTeucard,
        };

  const handleDesignCard = () => {
    Swal.fire({
      icon: "question",
      title: "Solicitar a 2º via?",
      text: `Ao solicitar a 2º via será cobrada uma taxa de ${tipoCartaoSelecionado === TIPO_CARTAO_CONVENIO ? "R$5,00" : "R$10,00"}.`,
      showCancelButton: true,
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#33A733",
    }).then((result) => {
      if (result.isConfirmed) {
        history.push({
          pathname: RouteNames.BLOQUEIO_DESIGN_CARTAO,
          state: { ...cartaoSelecionado, tipoCartaoSelecionado },
        });
      }
    });
  };

  return (
    <div className="motivo-roubo-furto-content">
      <h1 id="motivo-roubo-furto-title">Cartão bloqueado!</h1>

      <h3 id="motivo-roubo-furto-description">
        <span>Motivo: {selecionado?.descricao}</span>
        <br />
        Deseja Solicitar a 2ª via do cartão?
      </h3>

      <div className="motivo-roubo-furto-buttons">
        <div className="motivo-roubo-furto-center-buttons">
          {/* O usuário clica aqui quando NÃO quiser solicitar a segunda via,
                    a informação da escolha é reaproveitada na próxima tela */}
          <AppButton
            content="Não"
            outlined={false}
            click={() =>
              history.push({
                pathname: RouteNames.ATENDIMENTO_HOME,
              })
            }
          />

          <button
            style={{ width: "300px" }}
            className={`normal`}
            onClick={() => handleDesignCard()}
          >
            Sim
          </button>
        </div>
      </div>

      <img id="motivo-roubo-furto-padlock" src={lock_icon} alt="" />
    </div>
  );
};

export default BloqueioQuerSegundaVia;
